import React from 'react'
import ReactDOM from 'react-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { simpleHttp } from './http/simpleHttp'
import { HttpConfigType } from './http/type'
import UserService from './services/user/user.service'

import store from './redux/store'
import { Provider } from 'react-redux'

// import { UserType } from './services/user/type.d'
import { UserAzureType } from './services/user/type.d'

declare const window: HttpConfigType

const loadUserFromLocalStorage: VoidFunction = (): void => {
  const userStr: string | null = localStorage.getItem('user')
  if (userStr) {
    // const user: UserType = JSON.parse(userStr)
    const user: UserAzureType = JSON.parse(userStr)
    UserService.setCurrentUser(user)
  }
}

const persistor: any = persistStore(store)

const renderApp: VoidFunction = (): void => {
  ReactDOM.render(
    // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>,
    // </React.StrictMode>,
    document.getElementById('root')
  )
}

const initHttpAndRenderApp: VoidFunction = (): void => {
  simpleHttp
    .get(``)
    .then((res: any): void => {
      window.httpConfig = res.data
      renderApp()
    })
    .catch((): void => {
      renderApp()
    })
}

const initApp: any = async (): Promise<any> => {
  loadUserFromLocalStorage()

  if (!process.env.REACT_APP_API_URL) {
    initHttpAndRenderApp()
  } else {
    renderApp()
  }
}

initApp()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
